<template>
    <CCardText>
        <slot />
    </CCardText>
</template>

<script setup>
import { CCardText } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
